import { Injectable } from '@angular/core';

export interface PropertySetOperationsTracker {
  trackOperation(operation: PropertySetOperation): void;
  hasOperationsTracked(): boolean;
  hasMadeOperation(operation: PropertySetOperation): boolean;
  clearOperations(): void;
}

export enum PropertySetOperation {
  CreatedPS = 'CreatedPS',
  DeletedPS = 'DeletedPS',
  UpdatedPS = 'UpdatedPS',
  UpdatedPSPermission = 'UpdatedPSPermission',
  CreatedPSPermission = 'CreatedPSPermission',
  AddedPSPermission = 'AddedPSPermission',
  DeletedPSPermission = 'DeletedPSPermission',
  AddedPropertyToPS = 'AddedPropertyToPS',
  DeletedPropertyFromPS = 'DeletedPropertyFromPS',
}

@Injectable({ providedIn: 'root' })
export class PropertySetOperationsTrackerService implements PropertySetOperationsTracker {
  #actionsTracked = new Map<PropertySetOperation, boolean>();

  trackOperation(operation: PropertySetOperation) {
    if (!Object.values(PropertySetOperation).includes(operation)) return null;
    this.#actionsTracked.set(operation, true);
  }

  hasOperationsTracked() {
    return this.#actionsTracked.size > 0;
  }

  hasMadeOperation(operation: PropertySetOperation) {
    return this.#actionsTracked.has(operation);
  }

  clearOperations() {
    this.#actionsTracked.clear();
  }
}
